var userAgent = require('../internals/engine-user-agent');

module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/engine-is-ios.js
// module id = K7NN
// module chunks = 0